import { getDoc, setDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import defaultConfig from '../config/landing.config';

const CONFIG_DOC_PATH = 'config/landing';
const generateWhatsAppLink = (phone, message) =>
    `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  

const safe = (obj, fallback) =>
  typeof obj === 'object' && obj !== null ? obj : fallback;

export const getLandingConfig = async () => {
  try {
    const docRef = doc(db, CONFIG_DOC_PATH);
    const snap = await getDoc(docRef);

    if (snap.exists()) {
      const data = snap.data();

      return {
        ...defaultConfig,
        ...data,
        googleTagId: data.googleTagId || defaultConfig.googleTagId,
        hero: {
          ...defaultConfig.hero,
          ...safe(data.hero, {})
        },
        services: Array.isArray(data.services)
          ? data.services
          : defaultConfig.services,
          
          whatsappPhone: data.whatsappPhone || defaultConfig.whatsappPhone,
          whatsappMessage: data.whatsappMessage || defaultConfig.whatsappMessage,
          whatsappModal: {
            ...defaultConfig.whatsappModal,
            ...safe(data.whatsappModal, {}),
            link: generateWhatsAppLink(
              data.whatsappPhone || defaultConfig.whatsappPhone,
              data.whatsappMessage || defaultConfig.whatsappMessage
            ),
          },
        login: {
          ...defaultConfig.login,
          ...safe(data.login, {})
        },
        form: {
          ...defaultConfig.form,
          ...safe(data.form, {})
        },
        calendar: {
          ...defaultConfig.calendar,
          ...safe(data.calendar, {})
        },
        whatsappFloat: {
            link: generateWhatsAppLink(
              data.whatsappPhone || defaultConfig.whatsappPhone,
              data.whatsappMessage || defaultConfig.whatsappMessage
            )
          },
        animations: {
          ...defaultConfig.animations,
          ...safe(data.animations, {})
        },
        theme: {
          ...(defaultConfig.theme || {}),
          ...safe(data.theme, {}),
        },
      };
    } else {
      await setDoc(docRef, defaultConfig);
      return defaultConfig;
    }
  } catch (err) {
    console.error('❌ Error cargando config desde Firebase:', err);
    return defaultConfig;
  }
};
